import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-36 pb-16 md:pt-44 md:pb-24 px-4 relative overflow-hidden" data-id="element-80">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-81">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#C8956C]/10 rounded-full blur-3xl" data-id="element-82" />
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-[#7C9A6E]/10 rounded-full blur-3xl" data-id="element-83" />
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-85">
          <span className="inline-block py-1 px-3 rounded-full bg-[#C8956C]/10 text-[#C8956C] font-bold text-sm tracking-wider mb-6" data-id="element-86">
            MÉTODO 100% NATURAL
          </span>
          <h1 className="font-heading font-bold text-[#3D2B1F] leading-tight mb-6" data-id="element-87">
            <span className="block text-3xl md:text-5xl lg:text-6xl mb-2" data-id="element-88">
              Drenaje Brasileño "En Casa":
            </span>
            <span className="block text-xl md:text-3xl lg:text-4xl font-semibold text-[#5A4332]" data-id="element-89">
              El Método Maestro para un Abdomen Plano y Cintura Definida en 15
              Minutos
            </span>
          </h1>
          <h2 className="text-xl md:text-2xl text-[#5A4332] mb-10 font-light leading-relaxed max-w-3xl mx-auto" data-id="element-90">
            Reduce de 2 a 5 cm de inflamación desde la primera sesión con el
            secreto manual que las clínicas estéticas no quieren que hagas tú
            misma.
          </h2>
        </motion.div>

        {/* iPad Cover Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.15
      }} className="mb-12 flex justify-center" data-id="element-91">
          <div className="relative max-w-sm md:max-w-md" data-id="element-92">
            {/* Soft glow behind the image */}
            <div className="absolute inset-0 bg-[#C8956C]/20 rounded-3xl blur-2xl scale-90" data-id="element-93" />
            <img src="https://cdn.magicpatterns.com/uploads/w6hF6k8m5mHmtyzfz52cSZ/Diseno_sin_titulo_(1).png" alt="Guía Drenaje Brasileño en Casa - Vista en iPad" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl" data-id="element-94" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 rounded-2xl shadow-xl border border-[#C8956C]/10 text-left mb-10 relative" data-id="element-95">
          <div className="absolute -top-4 -left-4 text-6xl text-[#C8956C]/20 font-heading" data-id="element-96">
            "
          </div>
          <p className="text-lg text-[#5A4332] leading-relaxed relative z-10" data-id="element-97">
            Te despiertas, te miras al espejo y ahí está otra vez: esa pesadez
            abdominal que te hace sentir que tu cuerpo no te pertenece. Intentas
            subir la cremallera de tu jean favorito y se detiene a mitad de
            camino, no porque hayas subido de peso, sino porque tu cuerpo está
            atrapado en un ciclo de retención de líquidos y estancamiento
            linfático.
            <br data-id="element-98" />
            <br data-id="element-99" />
            <strong data-id="element-100">No eres tú, es tu linfa.</strong> Ese "bulto" en el vientre
            bajo y la pérdida de definición en la cintura no siempre es grasa;
            es líquido estancado que tu cuerpo no sabe cómo expulsar, y ninguna
            dieta o abdominal va a moverlo si no activas las "llaves" correctas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex justify-center" data-id="element-101">
          <Button className="animate-pulse-slow group" data-id="element-102">
            ¡SÍ, QUIERO EMPEZAR MI TRANSFORMACIÓN!
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-103" />
          </Button>
        </motion.div>
      </div>
    </section>;
}